import type { WeatherCondition } from '@daily/shared';

export interface WeatherTheme {
  gradient: string;
  ink: string;
}

export function weatherTheme(condition: WeatherCondition): WeatherTheme {
  switch (condition) {
    case 'clear':
    case 'fair':
      return {
        gradient: 'linear-gradient(135deg, #FFD580 0%, #FFA952 50%, #FF7849 100%)',
        ink: '#1A1410',
      };
    case 'cloudy':
    case 'overcast':
      return {
        gradient: 'linear-gradient(135deg, #C8CED6 0%, #8A98AB 100%)',
        ink: '#1A1410',
      };
    case 'rain':
    case 'showers':
      return {
        gradient: 'linear-gradient(135deg, #4A6B8A 0%, #1F2D44 100%)',
        ink: '#FFF8EB',
      };
    case 'snow':
      return {
        gradient: 'linear-gradient(135deg, #EAF1F8 0%, #B6C7D8 100%)',
        ink: '#1A1410',
      };
    case 'thunder':
      return {
        gradient: 'linear-gradient(135deg, #4A2A5B 0%, #14101A 100%)',
        ink: '#FFF8EB',
      };
    case 'fog':
      return {
        gradient: 'linear-gradient(135deg, #D8D2C8 0%, #A8A296 100%)',
        ink: '#1A1410',
      };
  }
}
